import { c as _c } from "react/compiler-runtime";
import { useController } from "react-hook-form";
import { useIntl } from "react-intl";
import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { FormField } from "uiShadcn/form";
import { Textarea } from "uiShadcn/textarea";
interface TextBoxProps {
  control: FormControlType;
  uiData: IFormInputs;
}
export default function TextBox(t0) {
  const $ = _c(14);
  const {
    control,
    uiData
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const name = uiData["x-json-schema-reference-property"];
  let t1;
  if ($[0] !== uiData.required) {
    t1 = uiData?.required?.includes("true");
    $[0] = uiData.required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRequired = t1;
  const numbersOnly = uiData?.format === "numeric";
  let t2;
  if ($[2] !== control || $[3] !== name) {
    t2 = {
      name,
      control
    };
    $[2] = control;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    fieldState: t3
  } = useController(t2);
  const {
    error
  } = t3;
  const showDescription = numbersOnly && !error;
  if (!name) {
    return null;
  }
  let t4;
  if ($[5] !== formatMessage || $[6] !== isRequired || $[7] !== showDescription || $[8] !== uiData.description) {
    t4 = t5 => {
      const {
        field
      } = t5;
      return <FormItem label={uiData?.description} required={isRequired} description={showDescription ? formatMessage({
        id: "errors.invalid_string.patternNumberOnly"
      }) : undefined}><Textarea dataTestId={`Input-${field.name}`} placeholder={formatMessage({
          id: "enter"
        })} required={isRequired} {...field} /></FormItem>;
    };
    $[5] = formatMessage;
    $[6] = isRequired;
    $[7] = showDescription;
    $[8] = uiData.description;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== control || $[11] !== name || $[12] !== t4) {
    t5 = <FormField control={control} name={name} render={t4} />;
    $[10] = control;
    $[11] = name;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}